const Pages = () => {
    return (
      <div className="p-4">
        <h2 className="text-2xl font-semibold">Pages</h2>
        <p>This is the Single Blog page.</p>
      </div>
    );
  };
  
  export default Pages;  